// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-bQbC","placeholdersHeader":"styles_placeholdersHeader__1M0uX","editorStyle":"styles_editorStyle__3xD3a","placeholdersBox":"styles_placeholdersBox__1cCvn"};